import { ActionCreator, Action } from "redux";
import { IContentBySearchState } from "..";
import { QueryUpdatedAction } from "./QueryUpdatedAction";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { SearchThunk } from "./SearchThunk";
import { isNumber } from "lodash"

/**
 * User initiates a search
 * 
 * note: ThunkAction type parameters:
 * R = Return Type of the inner function
 * S = State (from getState())
 * E = Extra parameter
 * A = Action
 * 
 * @param query
 */
export const QueryUpdatedThunk: ActionCreator<ThunkAction<void, IContentBySearchState, void, Action>> = (query: string) => {
    return (dispatch: ThunkDispatch<IContentBySearchState, void, Action>): void => {
        dispatch(QueryUpdatedAction(query));
        let timer = (<any>window)["spoQueryUpdatedTimer"]; 
        if(isNumber(timer)) {
            clearTimeout(timer);
        }
        (<any>window)["spoQueryUpdatedTimer"] = setTimeout(() => { dispatch(SearchThunk(true, true)) }, 1000);
    }
}